import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import '@/assets/styles/index.scss'

import './permission'
import RichEditor from '@/components/RichEditor/index.vue'

Vue.use(ElementUI, { size: 'small' })
Vue.component('RichEditor', RichEditor)

Vue.config.productionTip = false

// 静默处理 Vue Router 的预期重定向/重复导航错误，避免控制台报错
Vue.config.errorHandler = (err, vm, info) => {
  if (err && (err.name === 'NavigationDuplicated' || err.name === 'NavigationRedirected')) {
    return
  }
  if (typeof console !== 'undefined' && console.error) {
    console.error(err, info)
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
